import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index/index'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '智垒网科技术有限公司'
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/pages/about/index'),
      meta: {
        title: '智垒网科技术有限公司'
      }
    },
    {
      path: '/zlTravel',
      name: 'zlTravel',
      component: () => import('@/pages/zlTravel/index'),
      meta: {
        title: '智垒网科技术有限公司'
      }
    },
    {
      path: '/cusKc',
      name: 'cusKc',
      component: () => import('@/pages/cusKc/index'),
      meta: {
        title: '智垒网科技术有限公司'
      }
    },
    {
      path: '/stories',
      name: 'stories',
      component: () => import('@/pages/sucStories/index'),
      meta: {
        title: '智垒网科技术有限公司'
      }
    },
    {
      path: '/process',
      name: 'process',
      component: () => import('@/pages/process/index'),
      meta: {
        title: '智垒网科技术有限公司'
      }
    },
    {
      path: '/commonproblem',
      name: 'commonproblem',
      component: () => import('@/pages/comProblem/index'),
      meta: {
        title: '智垒网科技术有限公司'
      }
    },
    {
      path: '/szgj',
      name: 'szgj',
      component: () => import('@/pages/product/szgj/index'),
      meta: {
        title: '智垒网科技术有限公司'
      }
    },
    
    {
      path: '/szbc',
      name: 'szbc',
      component: () => import('@/pages/product/szbc/index'),
      meta: {
        title: '智垒网科技术有限公司'
      }
    },
    {
      path: '/taxi',
      name: 'taxi',
      component: () => import('@/pages/product/taxi/index'),
      meta: {
        title: '智垒网科技术有限公司'
      }
    },
    {
      path: '/tourismSystem',
      name: 'tourismSystem',
      component: () => import('@/pages/product/TourismSystem/index'),
      meta: {
        title: '智垒网科技术有限公司'
      }
    }



  ],
  scrollBehavior (to, from, savedPosition) {
    console.log('savedPosition', savedPosition)
    console.log('to', to);
    console.log('from', from);
    // keep-alive 返回缓存页面后记录浏览位置
    if (savedPosition && to.meta.keepAlive) {
      return savedPosition;
    }
    // 异步滚动操作
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 1 });
      }, 0);
    });
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js